/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit GetHelp.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromFlow from 'Logic/ViewsFlow.js'
import Message from './Message/view.js'
import React from 'react'
import Send from './Send/view.js'
import useIsBefore from 'Logic/useIsBefore.js'
import useIsHovered from 'Logic/useIsHovered.js'
import { DialogOverlay as ViewsModalOverlay, DialogContent as ViewsModalOverlayContent } from '@reach/dialog'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  alignItems: "center",
backgroundColor: "rgb(0, 188, 112)",
bottom: 0,
justifyContent: "center",
left: 0,
position: "fixed",
right: 0,
top: 0,
zIndex: 1000,
  
transition: 'opacity 150ms linear',
willChange: 'opacity',
  opacity: 'var(--opacity)'})
styles.Vertical1 = css({label: 'Vertical1',
  backgroundColor: "#ffffff",
borderBottomLeftRadius: 15,
borderBottomRightRadius: 15,
borderTopLeftRadius: 15,
borderTopRightRadius: 15,
paddingBottom: 50,
paddingLeft: 50,
paddingRight: 50,
paddingTop: 50,
marginLeft: 8,
marginRight: 8,
boxShadow: "0px 10px 30px 0px rgba(0, 161, 96, 1)",
width: 400})

export default function GetHelp({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/RuntimeError/GetHelp"
}) {
    let isBefore = useIsBefore()
    let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
    
    let setFlowTo = fromFlow.useSetFlowTo(viewPath)
    
    

  return (<React.Fragment
>
<ViewsModalOverlay
 data-testid="GetHelp.Vertical"
 data-view-path="/App/RuntimeError/GetHelp"
 isOpen={true}
 onClick={() => setFlowTo("/App/RuntimeError/Error")}
 {...isHoveredBind}
 style={{'--opacity': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<ViewsModalOverlayContent
 data-testid="GetHelp.Vertical:1"
 data-view-path="/App/RuntimeError/GetHelp"
 className={`views-block ${styles.Vertical1}`}
>
<Message
 data-testid="GetHelp.Message"
 data-view-path="/App/RuntimeError/GetHelp"
viewPath={`${viewPath}/Message`}
/>
<Send
 data-testid="GetHelp.Send"
 data-view-path="/App/RuntimeError/GetHelp"
viewPath={`${viewPath}/Send`}
/>
</ViewsModalOverlayContent>
</ViewsModalOverlay>
{children}
</React.Fragment>)
}